export default "__VITE_ASSET__B049zJM4__"